// 1.

// import { Box, useTheme } from '@mui/material';
// import React from 'react';
// import { Line } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Filler,
//     Legend,
// } from 'chart.js';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Filler,
//     Legend
// );

// function EnergyChartPower({ data, labels, title }) {
//     const { typography } = useTheme();

//     return (
//         <Line
//             style={{ overflow: 'scroll' }}
//             options={{
//                 responsive: true,
//                 maintainAspectRatio: true,
//                 animation: false,
//                 plugins: {
//                     legend: {
//                         position: 'top',
//                         display: true,
//                     },
//                     title: {
//                         display: false,
//                         position: 'left',
//                         text: 'Temperature in Celsius Degree',
//                     },
//                     tooltip: {
//                         mode: 'index',
//                         intersect: false,
//                     },
//                     filler: {
//                         propagate: true,
//                     },
//                 },
//                 spacing: 1,
//                 aspectRatio: 4,
//                 scales: {
//                     y: {
//                         ticks: {
//                             font: {
//                                 size: 10,
//                             },
//                         },
//                     },
//                     x: {
//                         ticks: {
//                             font: {
//                                 size: 10,
//                             },
//                         },
//                     },
//                 },
//             }}
//             data={{
//                 labels: labels,
//                 datasets: data,
//             }}
//         />
//     );
// }

// export default EnergyChartPower;





//2 This chart mobile view friendly

import { Box, useTheme } from '@mui/material';
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

function EnergyChartPower({ data, labels, title }) {
    const { typography } = useTheme();

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '100%',
                height: { xs: '250px', sm: '300px', md: '350px' }, // mobile-friendly heights
            }}
        >
            <Line
                options={{
                    responsive: true,
                    maintainAspectRatio: false, // ✅ Key to mobile responsiveness
                    animation: false,
                    plugins: {
                        legend: {
                            position: 'top',
                            display: true,
                        },
                        title: {
                            display: !!title,
                            text: title,
                            align: 'start',
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                        },
                        filler: {
                            propagate: true,
                        },
                    },
                    scales: {
                        y: {
                            ticks: {
                                font: {
                                    size: 10,
                                },
                            },
                        },
                        x: {
                            ticks: {
                                font: {
                                    size: 10,
                                },
                            },
                        },
                    },
                }}
                data={{
                    labels: labels,
                    datasets: data,
                }}
            />
        </Box>
    );
}

export default EnergyChartPower;


// import { Box, useTheme } from '@mui/material';
// import React from 'react';
// import { Line } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Filler,
//     Legend,
// } from 'chart.js';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Filler,
//     Legend
// );

// function EnergyChartPower({ data, labels, title }) {
//     const { typography } = useTheme();

//     return (
//         <Box sx={{ width: '100%', overflowX: 'auto' }}> 
//             <Line
//                 options={{
//                     responsive: true,
//                     maintainAspectRatio: false, // Allow full responsiveness
//                     animation: false,
//                     plugins: {
//                         legend: {
//                             position: 'top',
//                             display: true,
//                         },
//                         title: {
//                             display: title ? true : false,
//                             text: title || '',
//                             font: { size: 14 },
//                         },
//                         tooltip: {
//                             mode: 'index',
//                             intersect: false,
//                         },
//                         filler: {
//                             propagate: true,
//                         },
//                     },
//                     scales: {
//                         y: {
//                             ticks: {
//                                 font: {
//                                     size: window.innerWidth < 768 ? 8 : 12, // Adjust font size for mobile
//                                 },
//                             },
//                         },
//                         x: {
//                             ticks: {
//                                 font: {
//                                     size: window.innerWidth < 768 ? 8 : 12, // Adjust font size for mobile
//                                 },
//                             },
//                         },
//                     },
//                 }}
//                 data={{
//                     labels: labels,
//                     datasets: data,
//                 }}
//             />
//         </Box>
//     );
// }

// export default EnergyChartPower;


